// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2m1if","label":"CategoryService_label__UQ8kN","location":"CategoryService_location__1aotE"};